// extracted by mini-css-extract-plugin
module.exports = {"limitsWrapper":"_aef5bea","labelContent":"_6e2ec9b"};